module.exports = __webpack_public_path__ + "static/media/poikiliamd_thumb1.ebf8f107.jpg";